export const fontAssets = {
  'DMSans-Bold': require('../assets/fonts/Lexend-ExtraBold.ttf'),
  'DMSans-Medium': require('../assets/fonts/Lexend-Medium.ttf'),
  'DMSans-Regular': require('../assets/fonts/Lexend-Regular.ttf'),
} as const;

export type LoadedFontFamily = keyof typeof fontAssets;
export const SYSTEM_FONT_FAMILY = 'System' as const;
export type FontFamily = LoadedFontFamily | typeof SYSTEM_FONT_FAMILY;

const createFontStyle = <T extends LoadedFontFamily>(fontFamily: T) => ({
  fontFamily,
});

const DMSans_400Regular = createFontStyle('DMSans-Regular');
const DMSans_500Medium = createFontStyle('DMSans-Medium');
const DMSans_700Bold = createFontStyle('DMSans-Bold');

export const fonts = {
  // H1-5
  H1: {...DMSans_700Bold, fontSize: 32, lineHeight: 32 * 1.3},
  H2: {...DMSans_700Bold, fontSize: 22, lineHeight: 22 * 1.4},
  H3: {...DMSans_500Medium, fontSize: 20, lineHeight: 20 * 1.2},
  H4: {...DMSans_500Medium, fontSize: 18, lineHeight: 18 * 1.2},
  H5: {...DMSans_500Medium, fontSize: 14, lineHeight: 14 * 1.2},
  // TS 14-16
  textStyle_14: {...DMSans_400Regular, fontSize: 14, lineHeight: 14 * 1.5},
  textStyle_16: {...DMSans_400Regular, fontSize: 16, lineHeight: 16 * 1.7},
  // DMSans
  DMSans_400Regular: {...DMSans_400Regular},
  DMSans_500Medium: {...DMSans_500Medium},
  DMSans_700Bold: {...DMSans_700Bold},
};
